// extracted by mini-css-extract-plugin
export default {"container":"j7-z","topReviewHeading":"k7-z","criticalReview":"l7-z","favorableReview":"m7-z","vsSeparator":"n7-z"};